//Company form data
export const formData = (parentCompanyListOption, cityOption, values, onboardingTitle,edit) => {
  return {
    [`${onboardingTitle}`]: [
      {
        textField: true,
        gridSize: 6,
        placeholder: 'Enter Company Name',
        required: true,
        type: 'companyName',
        name: 'name',
        label: 'Company name',
        star: '*',
      },
      // {
      //   singleAutoComplete: true,
      //   gridSize: 6,
      //   placeholder: 'Choose Parent Company Name',
      //   name: 'parentCompanyId',
      //   label: 'Parent Company Name',
      //   optionData: parentCompanyListOption || [],
      //   fieldDisabled: edit ? true:false,
      // },
      {
        textField: true,
        gridSize: 6,
        placeholder: 'Enter Company Address',
        required: true,
        type: 'text',
        name: 'address',
        label: 'Address',
      },
      {
        options: true,
        required: true,
        gridSize: 6,
        placeholder: 'Choose a City',
        type: 'text',
        name: 'cityId',
        label: 'City',
        menuOptions: cityOption,
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: 'Enter Pincode',
        required: true,
        type: 'number',
        name: 'pinCode',
        label: 'Pin Code',
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: 'Enter Company PAN',
        className: 'textCapital',
        required: true,
        type: 'text',
        name: 'panNumber',
        label: 'Company PAN',
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: 'Enter Email ID',
        required: true,
        type: 'email',
        name: 'email',
        label: 'Email ID',
        star: '*'
      },
      {
        textField: true,
        gridSize: 6,
        countrycode: true,
        placeholder: 'Enter Phone Number',
        required: true,
        type: 'number',
        name: 'phoneNumber',
        label: 'Phone Number',
        star: '*'
      },
        {
      textField: true,
      gridSize: 6,
      placeholder: 'Enter Admin Name',
      required: true,
      type: 'text',
      name: 'adminName',
      label: 'Name',
      star: '*',
    },
      // {
      //   name: "endOtpRequired",
      //   label: "",
      //   checkbox: true,
      //   gridSize: 6,
      //   required: false,
      //   subItems: [
      //     {
      //       name: "endOtpRequired",
      //       checkboxLablel: "Secure Trip End with OTP"
      //     }
      //   ]
      // },
      {
        emailDomain: true,
        gridSize: 12,
        name:'allowedDomain'
      },
      {
        dashedBorder: 'dashedBorder',
        border: 'dashed',
      },
    ],
    // 'Contract Details': [
    //   {
    //     datePicker: true,
    //     required: true,
    //     gridSize: 6,
    //     placeholder: '',
    //     type: 'date',
    //     name: 'chooseDate',
    //     label: 'Contract Date',
    //   },
    //   {
    //     dateRangePicker: true,
    //     required: true,
    //     gridSize: 6,
    //     placeholder: '',
    //     type: '',
    //     name: 'tenure',
    //     label: 'Tenure',
    //   },
    //   {
    //     dashedBorder: 'dashedBorder',
    //     border: 'dashed',
    //   },
    // ],
    // 'Office Details': [
    //   {
    //     cityOption: true,
    //     gridSize: 12,
    //     required: true,
    //     // label: "Choose Cities",
    //     placeholder: 'Choose a City',
    //     menuOptions: cityOption || [],
    //     checkboxOptions: [
    //       {
    //         id: '1',
    //         name: 'sez',
    //         checkboxLablel: 'SEZ( Special Economic Zone )',
    //       },
    //     ],
    //   },
    //   {
    //     dashedBorder: 'dashedBorder',
    //     border: 'dashed',
    //   },
    // ],
    // 'Billing Details': [
    //   {
    //     name: 'billingDetails',
    //     checkbox: true,
    //     required: true,
    //     gridSize: 12,
    //     subItems: [
    //       {
    //         id: "1",
    //         name: "billToCreditCard",
    //         checkboxLablel: "Bill to credit card",
    //       },
    //       {
    //         id: '2',
    //         name: 'billToCompany',
    //         checkboxLablel: 'Bill to company',
    //       },
    //     ],
    //   },
    //   {
    //     options: true,
    //     required: true,
    //     gridSize: 6,
    //     placeholder: 'Choose your Bill Submission Cycle',
    //     type: 'text',
    //     name: 'billingCycle',
    //     label: 'Bill Submission Cycle',
    //     menuOptions: [
    //       {
    //         label: 'Weekly',
    //         value: 'Weekly',
    //       },
    //       {
    //         label: 'Monthly',
    //         value: 'Monthly',
    //       },
    //       {
    //         label: 'Fortnightly',
    //         value: 'Fortnightly',
    //       },
    //     ],
    //   },
    //   {
    //     options: true,
    //     required: true,
    //     gridSize: 6,
    //     placeholder: 'Choose your Billing Type',
    //     type: 'text',
    //     name: 'invoiceType',
    //     label: 'Billing Type',
    //     menuOptions: [
    //       {
    //         label: 'Consolidated',
    //         value: 'Consolidated',
    //       },
    //       {
    //         label: 'Individual',
    //         value: 'Individual',
    //       },
    //     ],
    //   },
    //   {
    //     options: true,
    //     required: true,
    //     gridSize: 6,
    //     placeholder: 'Choose Duty Configuration',
    //     type: 'text',
    //     name: 'config',
    //     label: 'Duty Configuration',
    //     menuOptions: [
    //       {
    //         value: 'Point-To-Point',
    //         label: 'Is Point to Point',
    //       },
    //       {
    //         value: 'Point-To-Garage',
    //         label: 'Is Point to Point with Fixed Garage Run',
    //       },
    //       {
    //         value: 'Garage-To-Garage',
    //         label: 'Is Garage to Garage',
    //       },
    //     ],
    //   },
    //   {
    //     garageRateConfig: true,
    //     gridSize: 12,
    //     name: 'garageRateConfig',
    //     label: '',
    //     conditionalField: 'config',
    //   },
    //   {
    //     textField: true,
    //     gridSize: 6,
    //     placeholder: 'Fixed garage run',
    //     rupee: true,
    //     type: 'number',
    //     name: 'configRate',
    //     label: 'Fixed garage run',
    //   },
    //   {
    //     textField: true,
    //     gridSize: 6,
    //     placeholder: 'Choose Approve or Dispute Duration',
    //     required: false,
    //     type: 'number',
    //     name: 'approvalDuration',
    //     label: 'Approve or Dispute Duration (in hr)',
    //   },
    //   {
    //     fileUpload: true,
    //     required: true,
    //     gridSize: 6,
    //     name: 'InsuranceFile',
    //     label: 'Upload Agreement',
    //     defaultValue: values?.Contracts?.[0]?.agreement,
    //   },

    //   {
    //     multifileUpload: true,
    //     required: false,
    //     gridSize: 6,
    //     name: 'DocumentFile',
    //     label: 'Upload Documents',
    //     defaultValue: values?.docs,
    //   },
    // ],
  };
};

// export const GSTFormData = {
//   'Admin Team Details': [
//     {
//       textField: true,
//       gridSize: 6,
//       placeholder: 'Enter Admin Name',
//       required: true,
//       type: 'text',
//       name: 'adminName',
//       label: 'Name',
//       star: '*',
//     },
//     {
//       textField: true,
//       gridSize: 6,
//       required: true,
//       placeholder: 'Enter Admin Email ID',
//       type: 'text',
//       name: 'adminEmail',
//       label: 'Email ID',
//       star: '*',
//     },
//     {
//       textField: true,
//       gridSize: 6,
//       required: true,
//       placeholder: 'Enter Admin Phone Number',
//       type: 'number',
//       countrycode: true,
//       name: 'phoneNumber',
//       label: 'Phone No.',
//       star: '*',
//     },
//     {
//       dashedBorder: 'dashedBorder',
//       border: 'dashed',
//     },
//   ],

//   'Finance Team Details': [
//     {
//       textField: true,
//       gridSize: 6,
//       placeholder: 'Enter Finance Team Name',
//       required: false,
//       type: 'text',
//       name: 'financeName',
//       label: 'Name',
//       star: '*',
//     },
//     {
//       textField: true,
//       gridSize: 6,
//       placeholder: 'Enter Finance Team Email ID',
//       required: false,
//       type: 'email',
//       name: 'financeEmail',
//       label: 'Email ID',
//     },
//     {
//       textField: true,
//       gridSize: 6,
//       countrycode: true,
//       placeholder: 'Enter Finance Team Phone Number',
//       required: false,
//       type: 'number',
//       name: 'mobileNumber',
//       label: 'Phone No.',
//     },
//     {
//       dashedBorder: 'dashedBorder',
//       border: 'dashed',
//     },
//   ],
// };

export const companyFilterData = (cityOption) => [
  {
    id: 1,
    primaryText: 'Location',
    subItems: cityOption,
  },
  {
    id: 2,
    primaryText: 'Status',
    subItems: [
      { value: 'Active', key: 'Status' },
      { value: 'InActive', key: 'Status' },
      { value: 'Provision Pending', key: 'Status' },
      { value: 'Provisioned', key: 'Status' },
      { value: 'InProgress', key: 'Status' },
    ],
  },
];
